"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useI18n = exports.TransProvider = void 0;
var react_1 = __importStar(require("react"));
var local_storage_1 = require("./local-storage");
var DEFAULT_LOCAL_STORAGE_KEY = 'lang';
var Context = (0, react_1.createContext)({});
var TransProvider = function (_a) {
    var i18n = _a.i18n, specifiedDefaultLang = _a.defaultLang, _b = _a.enableLocalStorage, enableLocalStorage = _b === void 0 ? true : _b, _c = _a.localStorageKey, localStorageKey = _c === void 0 ? DEFAULT_LOCAL_STORAGE_KEY : _c, children = _a.children;
    if (!i18n) {
        throw new Error('Resources of i18n are Required.');
    }
    if (typeof i18n !== 'object' ||
        !Object.keys(i18n)[0] ||
        Array.isArray(i18n)) {
        throw new Error('i18n file is not valid. See here for more information on the format: https://github.com/shinshin86/use-mini18n#usage');
    }
    var DEFAULT_LANG = Object.keys(i18n)[0];
    var langs = Object.keys(i18n);
    var _d = (0, react_1.useState)(specifiedDefaultLang && langs.includes(specifiedDefaultLang)
        ? specifiedDefaultLang
        : DEFAULT_LANG), lang = _d[0], setLang = _d[1];
    var _e = (0, react_1.useState)(i18n[lang]), text = _e[0], setText = _e[1];
    var changeLang = function (lang) {
        if (enableLocalStorage) {
            (0, local_storage_1.saveLangSetting)(window, lang, localStorageKey);
        }
        setLang(lang);
        setText(i18n[lang]);
    };
    var getText = (0, react_1.useCallback)(function (key, params) {
        var t = text[key];
        if (!t)
            throw new Error('use-mini18n error: Not found key');
        for (var _i = 0, _a = Object.keys(params); _i < _a.length; _i++) {
            var k = _a[_i];
            var r = "{" + k + "}";
            t = t.replace(r, params[k]);
        }
        return t;
    }, [text]);
    (0, react_1.useEffect)(function () {
        var defaultLang = (enableLocalStorage && (0, local_storage_1.loadLangSetting)(window, langs, localStorageKey)) ||
            DEFAULT_LANG;
        var initLang = specifiedDefaultLang && langs.includes(specifiedDefaultLang)
            ? specifiedDefaultLang
            : defaultLang;
        changeLang(initLang);
    }, []);
    return (react_1.default.createElement(Context.Provider, { value: {
            lang: lang,
            langs: langs,
            text: text,
            changeLang: changeLang,
            getText: getText,
        } }, children));
};
exports.TransProvider = TransProvider;
var useI18n = function () {
    var _a = (0, react_1.useContext)(Context), t = _a.text, lang = _a.lang, langs = _a.langs, changeLang = _a.changeLang, getText = _a.getText;
    return { t: t, lang: lang, langs: langs, changeLang: changeLang, getText: getText };
};
exports.useI18n = useI18n;
